import { v as z, n as oe, _ as M, P as et, d as g, h as tt, k as nt } from "./CSSMotionList.js";
import * as s from "react";
import rt, { useState as se, useMemo as Ie, useCallback as _e } from "react";
import { K as l } from "./Keyframes.js";
import { i as Ce } from "./Portal.js";
import { _ as E } from "./extends.js";
import { R as Ne } from "./index5.js";
import { unstable_batchedUpdates as at } from "react-dom";
const it = new l("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), st = new l("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), ot = new l("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), ft = new l("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), lt = new l("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), mt = new l("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), ct = new l("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
}), ut = new l("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
}), dt = {
  "move-up": {
    inKeyframes: ct,
    outKeyframes: ut
  },
  "move-down": {
    inKeyframes: it,
    outKeyframes: st
  },
  "move-left": {
    inKeyframes: ot,
    outKeyframes: ft
  },
  "move-right": {
    inKeyframes: lt,
    outKeyframes: mt
  }
}, Ft = (e, i) => {
  const {
    antCls: m
  } = e, r = `${m}-${i}`, {
    inKeyframes: f,
    outKeyframes: a
  } = dt[i];
  return [Ce(r, f, a, e.motionDurationMid), {
    [`
        ${r}-enter,
        ${r}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: e.motionEaseOutCirc
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInOutCirc
    }
  }];
}, vt = new l("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), yt = new l("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), pt = new l("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
}), gt = new l("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
}), Rt = new l("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
}), Ot = new l("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
}), St = new l("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
}), wt = new l("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
}), ht = {
  "slide-up": {
    inKeyframes: vt,
    outKeyframes: yt
  },
  "slide-down": {
    inKeyframes: pt,
    outKeyframes: gt
  },
  "slide-left": {
    inKeyframes: Rt,
    outKeyframes: Ot
  },
  "slide-right": {
    inKeyframes: St,
    outKeyframes: wt
  }
}, Tt = (e, i) => {
  const {
    antCls: m
  } = e, r = `${m}-${i}`, {
    inKeyframes: f,
    outKeyframes: a
  } = ht[i];
  return [Ce(r, f, a, e.motionDurationMid), {
    [`
      ${r}-enter,
      ${r}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: e.motionEaseOutQuint,
      "&-prepare": {
        transform: "scale(1)"
      }
    },
    [`${r}-leave`]: {
      animationTimingFunction: e.motionEaseInQuint
    }
  }];
};
var Et = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"], K = void 0;
function It(e, i) {
  var m = e.prefixCls, r = e.invalidate, f = e.item, a = e.renderItem, c = e.responsive, R = e.responsiveDisabled, v = e.registerSize, I = e.itemKey, _ = e.className, B = e.style, H = e.children, q = e.display, u = e.order, U = e.component, W = U === void 0 ? "div" : U, b = z(e, Et), y = c && !q;
  function L(O) {
    v(I, O);
  }
  s.useEffect(function() {
    return function() {
      L(null);
    };
  }, []);
  var J = a && f !== K ? a(f, {
    index: u
  }) : H, C;
  r || (C = {
    opacity: y ? 0 : 1,
    height: y ? 0 : K,
    overflowY: y ? "hidden" : K,
    order: c ? u : K,
    pointerEvents: y ? "none" : K,
    position: y ? "absolute" : K
  });
  var X = {};
  y && (X["aria-hidden"] = !0);
  var S = /* @__PURE__ */ s.createElement(W, E({
    className: oe(!r && m, _),
    style: M(M({}, C), B)
  }, X, b, {
    ref: i
  }), J);
  return c && (S = /* @__PURE__ */ s.createElement(Ne, {
    onResize: function(Z) {
      var A = Z.offsetWidth;
      L(A);
    },
    disabled: R
  }, S)), S;
}
var P = /* @__PURE__ */ s.forwardRef(It);
P.displayName = "Item";
function _t(e) {
  if (typeof MessageChannel > "u")
    et(e);
  else {
    var i = new MessageChannel();
    i.port1.onmessage = function() {
      return e();
    }, i.port2.postMessage(void 0);
  }
}
function Ct() {
  var e = s.useRef(null), i = function(r) {
    e.current || (e.current = [], _t(function() {
      at(function() {
        e.current.forEach(function(f) {
          f();
        }), e.current = null;
      });
    })), e.current.push(r);
  };
  return i;
}
function $(e, i) {
  var m = s.useState(i), r = g(m, 2), f = r[0], a = r[1], c = tt(function(R) {
    e(function() {
      a(R);
    });
  });
  return [f, c];
}
var Q = /* @__PURE__ */ rt.createContext(null), Nt = ["component"], Kt = ["className"], Mt = ["className"], bt = function(i, m) {
  var r = s.useContext(Q);
  if (!r) {
    var f = i.component, a = f === void 0 ? "div" : f, c = z(i, Nt);
    return /* @__PURE__ */ s.createElement(a, E({}, c, {
      ref: m
    }));
  }
  var R = r.className, v = z(r, Kt), I = i.className, _ = z(i, Mt);
  return /* @__PURE__ */ s.createElement(Q.Provider, {
    value: null
  }, /* @__PURE__ */ s.createElement(P, E({
    ref: m,
    className: oe(R, I)
  }, v, _)));
}, Ke = /* @__PURE__ */ s.forwardRef(bt);
Ke.displayName = "RawItem";
var xt = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"], Me = "responsive", be = "invalidate";
function Dt(e) {
  return "+ ".concat(e.length, " ...");
}
function $t(e, i) {
  var m = e.prefixCls, r = m === void 0 ? "rc-overflow" : m, f = e.data, a = f === void 0 ? [] : f, c = e.renderItem, R = e.renderRawItem, v = e.itemKey, I = e.itemWidth, _ = I === void 0 ? 10 : I, B = e.ssr, H = e.style, q = e.className, u = e.maxCount, U = e.renderRest, W = e.renderRawRest, b = e.suffix, y = e.component, L = y === void 0 ? "div" : y, J = e.itemComponent, C = e.onVisibleChange, X = z(e, xt), S = B === "full", O = Ct(), Z = $(O, null), A = g(Z, 2), F = A[0], xe = A[1], w = F || 0, De = $(O, /* @__PURE__ */ new Map()), fe = g(De, 2), le = fe[0], $e = fe[1], ze = $(O, 0), me = g(ze, 2), Pe = me[0], Ue = me[1], We = $(O, 0), ce = g(We, 2), T = ce[0], Le = ce[1], Xe = $(O, 0), ue = g(Xe, 2), Y = ue[0], Ae = ue[1], Fe = se(null), de = g(Fe, 2), ee = de[0], ve = de[1], Te = se(null), ye = g(Te, 2), V = ye[0], Ye = ye[1], N = s.useMemo(function() {
    return V === null && S ? Number.MAX_SAFE_INTEGER : V || 0;
  }, [V, F]), Ve = se(!1), pe = g(Ve, 2), je = pe[0], Ge = pe[1], te = "".concat(r, "-item"), ge = Math.max(Pe, T), ne = u === Me, p = a.length && ne, Re = u === be, Qe = p || typeof u == "number" && a.length > u, h = Ie(function() {
    var t = a;
    return p ? F === null && S ? t = a : t = a.slice(0, Math.min(a.length, w / _)) : typeof u == "number" && (t = a.slice(0, u)), t;
  }, [a, _, F, u, p]), re = Ie(function() {
    return p ? a.slice(N + 1) : a.slice(h.length);
  }, [a, h, p, N]), j = _e(function(t, n) {
    var o;
    return typeof v == "function" ? v(t) : (o = v && (t == null ? void 0 : t[v])) !== null && o !== void 0 ? o : n;
  }, [v]), ke = _e(c || function(t) {
    return t;
  }, [c]);
  function G(t, n, o) {
    V === t && (n === void 0 || n === ee) || (Ye(t), o || (Ge(t < a.length - 1), C == null || C(t)), n !== void 0 && ve(n));
  }
  function Be(t, n) {
    xe(n.clientWidth);
  }
  function Oe(t, n) {
    $e(function(o) {
      var d = new Map(o);
      return n === null ? d.delete(t) : d.set(t, n), d;
    });
  }
  function He(t, n) {
    Le(n), Ue(T);
  }
  function qe(t, n) {
    Ae(n);
  }
  function ae(t) {
    return le.get(j(h[t], t));
  }
  nt(function() {
    if (w && typeof ge == "number" && h) {
      var t = Y, n = h.length, o = n - 1;
      if (!n) {
        G(0, null);
        return;
      }
      for (var d = 0; d < n; d += 1) {
        var D = ae(d);
        if (S && (D = D || 0), D === void 0) {
          G(d - 1, void 0, !0);
          break;
        }
        if (t += D, // Only one means `totalWidth` is the final width
        o === 0 && t <= w || // Last two width will be the final width
        d === o - 1 && t + ae(o) <= w) {
          G(o, null);
          break;
        } else if (t + ge > w) {
          G(d - 1, t - D - Y + T);
          break;
        }
      }
      b && ae(0) + Y > w && ve(null);
    }
  }, [w, le, T, Y, j, h]);
  var Se = je && !!re.length, we = {};
  ee !== null && p && (we = {
    position: "absolute",
    left: ee,
    top: 0
  });
  var x = {
    prefixCls: te,
    responsive: p,
    component: J,
    invalidate: Re
  }, Je = R ? function(t, n) {
    var o = j(t, n);
    return /* @__PURE__ */ s.createElement(Q.Provider, {
      key: o,
      value: M(M({}, x), {}, {
        order: n,
        item: t,
        itemKey: o,
        registerSize: Oe,
        display: n <= N
      })
    }, R(t, n));
  } : function(t, n) {
    var o = j(t, n);
    return /* @__PURE__ */ s.createElement(P, E({}, x, {
      order: n,
      key: o,
      item: t,
      renderItem: ke,
      itemKey: o,
      registerSize: Oe,
      display: n <= N
    }));
  }, he = {
    order: Se ? N : Number.MAX_SAFE_INTEGER,
    className: "".concat(te, "-rest"),
    registerSize: He,
    display: Se
  }, ie = U || Dt, Ze = W ? /* @__PURE__ */ s.createElement(Q.Provider, {
    value: M(M({}, x), he)
  }, W(re)) : /* @__PURE__ */ s.createElement(P, E({}, x, he), typeof ie == "function" ? ie(re) : ie), Ee = /* @__PURE__ */ s.createElement(L, E({
    className: oe(!Re && r, q),
    style: H,
    ref: i
  }, X), h.map(Je), Qe ? Ze : null, b && /* @__PURE__ */ s.createElement(P, E({}, x, {
    responsive: ne,
    responsiveDisabled: !p,
    order: N,
    className: "".concat(te, "-suffix"),
    registerSize: qe,
    display: !0,
    style: we
  }), b));
  return ne ? /* @__PURE__ */ s.createElement(Ne, {
    onResize: Be,
    disabled: !p
  }, Ee) : Ee;
}
var k = /* @__PURE__ */ s.forwardRef($t);
k.displayName = "Overflow";
k.Item = Ke;
k.RESPONSIVE = Me;
k.INVALIDATE = be;
export {
  k as F,
  pt as a,
  yt as b,
  gt as c,
  Ft as d,
  Tt as i,
  vt as s
};
